import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RechargeSansInscriptionService } from './../../../api/recharge-sans-inscription.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-payment-recharge-sans-inscription',
  templateUrl: './confirm-payment-recharge-sans-inscription.component.html',
  styleUrls: ['./confirm-payment-recharge-sans-inscription.component.scss']
})
export class ConfirmPaymentRechargeSansInscriptionComponent implements OnInit {


  isSucceeded: boolean = false;
  isNotSucceeded: boolean = false;
  wait: boolean = false;

  subscription: Subscription;
  stationDetail: any;
  token: any;


  constructor(private rechargeSansInscriptionService: RechargeSansInscriptionService, private router: Router, private snackBar: MatSnackBar, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

    var url = new URL(location.href);
    var setup_intent = url.searchParams.get("payment_intent");

    if (setup_intent) {
      console.log("setup_intent");
      this.getStatus3DSecure()
    }
    else {

      let recharge_info = JSON.parse(localStorage.getItem('recharge_info'))
      if (recharge_info) {
        this.rechargeSansInscriptionService.postBookRecharge(recharge_info.access_token, { station_id: recharge_info.station.id }).subscribe(
          data => {
            console.log("postBookRecharge");
            console.log(data);
            this.stationDetail = recharge_info.station
            this.token = data.data.token
            localStorage.removeItem('recharge_info');

          },
          err => {
            console.log(err)
            this.errorSnackBarError(err.message)
          });

      }

    }


  }

  retourCompte() {
    this.router.navigate([`/`]);
  }



  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }




  getStatus3DSecure() {


    var url = new URL(location.href);

    var setup_intent = url.searchParams.get("payment_intent");
    console.log(setup_intent);



    this.rechargeSansInscriptionService.send3Dsecure(setup_intent).subscribe(
      data => {

        console.log("send3Dsecure");
        console.log(data);
        console.log(data.data.status);
        //requires_capture
        if (data.data.status === "requires_capture") {

          let recharge_info = JSON.parse(localStorage.getItem('recharge_info'))
          console.log("recharge_info");
          console.log(recharge_info);
          if (recharge_info) {

            this.rechargeSansInscriptionService.updateDriver(recharge_info.user.name, data.data.id).subscribe(
              data => {
                console.log('updateDriver')
                console.log(data)

                this.rechargeSansInscriptionService.postBookRecharge(recharge_info.user.access_token, { station_id: recharge_info.station.id }).subscribe(
                  data => {
                    console.log('postBookRecharge')
                    console.log(data)
                    this.stationDetail = recharge_info.station
                    this.token = data.data.token
                    localStorage.removeItem('recharge_info');

                  },
                  err => {
                    console.log(err)
                    //localStorage.removeItem('recharge_info');
                    this.errorSnackBarError('Votre paiement a été refusé')
                  });
              },
              err => {
                console.log(err)
                this.errorSnackBarError('update user fail')
              });

          }

        }
        else {
          console.log("send3Dsecure else")
          console.log(data.data)
          //localStorage.removeItem('recharge_info');
          this.errorSnackBarError('Votre paiement a été refusé')
        }
      },
      err => {
        console.log(err)
        //this.openSnackBar(err.error.message)
      });


  }



  StartCharge() {
    this.wait = true;
    let body = { token: this.token, action: "Start" }
    this.rechargeSansInscriptionService.postRemoteRecharge(body).subscribe(
      data => {
        this.wait = false;
        console.log(data)
        this.sucessSnackBarDone(data.message)
      },
      err => {
        console.log(err)
        this.errorSnackBarError(err.error.message)
      });
  }

  StopCharge() {
    this.wait = true;
    let body = { token: this.token, action: "Finish" }
    this.rechargeSansInscriptionService.postRemoteRecharge(body).subscribe(
      data => {
        this.wait = false;
        console.log(data)
        this.sucessSnackBarDone(data.message)
      },
      err => {
        console.log(err)
        this.errorSnackBarError(err.error.message)
      });
  }


  sucessSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 50000,
    });
  }


  errorSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 50000,
    });
  }

}
